// Date formatting utilities
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

// Enable UTC plugin
dayjs.extend(utc)

/**
 * Converts a YYYY-MM-DD key to a UTC midnight ISO string.
 * Using a template literal avoids local-timezone shift that
 * dayjs(key).startOf('day').toISOString() would introduce.
 */
export const keyToUtcIso = (key: string): string => `${key}T00:00:00.000Z`

/**
 * Builds the scheduled_dates array for a meal mutation.
 * sortedKeys must be sorted chronologically; sortedKeys[0] is the primary date.
 * primaryIso is the already-resolved ISO string for the primary date (may include time).
 */
export function buildScheduledDates(sortedKeys: string[], primaryIso: string): string[] {
  const [primaryKey] = sortedKeys
  return sortedKeys.map((key) => (key === primaryKey ? primaryIso : keyToUtcIso(key)))
}

/**
 * Formats a date string or timestamp to a localized date string
 * @param dateInput - Date string, timestamp, or Date object
 * @param options - Intl.DateTimeFormat options
 * @returns Formatted date string or 'Invalid Date' if parsing fails
 */
export function formatDate(
  dateInput: string
): string {
  if (dateInput === "" || dateInput === null) {
    return "Not provided"
  }

  const date = dayjs.utc(dateInput)
  const dateFormated = date.format('DD/MM/YYYY')
  return dateFormated
}
